import {
  GET_LIST_CHITIETCUAHANG,
  GET_LIST_CHITIETCUAHANG_SUCCESS,
  GET_LIST_CHITIETCUAHANG_FAILURE,
} from "./actionTypes";

export const getListChiTietCuaHang = (dataSearch) => ({
  type: GET_LIST_CHITIETCUAHANG,
  dataSearch,
});

export const getListChiTietCuaHangSuccess = (data) => ({
  type: GET_LIST_CHITIETCUAHANG_SUCCESS,
  payload: data,
});

export const getListChiTietCuaHangFailure = () => ({
  type: GET_LIST_CHITIETCUAHANG_FAILURE,
});
